export default __webpack_public_path__ + "static/media/acoer_logo_black.c86b5c64.svg";